// Find-your-matcha quiz overlay
(function () {
  const Q = [
    { q: "How do you usually drink it?", sub: "No wrong answers.",
      options: [
        { id:"latte", icon:"🥛", title:"Big oat-milk latte", tags:["lattes","everyday"] },
        { id:"neat", icon:"🍵", title:"Neat from a small bowl", tags:["sipping","ceremonial","umami"] },
        { id:"baking", icon:"🍪", title:"In cookies + smoothies", tags:["baking","smoothies"] },
        { id:"evening", icon:"🌙", title:"Cozy after dinner", tags:["evening","cozy"] },
      ]},
    { q: "Pick a flavor vibe.",
      options: [
        { id:"grassy", icon:"🌱", title:"Grassy & sweet", tags:["everyday","starter"] },
        { id:"deep", icon:"🍫", title:"Deep & umami", tags:["umami","sipping","ceremonial"] },
        { id:"toasty", icon:"🌾", title:"Toasty & cozy", tags:["cozy","evening"] },
        { id:"bold", icon:"⚡", title:"Bold & punchy", tags:["lattes","baking"] },
      ]},
    { q: "Caffeine, friend or foe?", three: true,
      options: [
        { id:"yes", icon:"🚀", title:"More please", tags:["umami","ceremonial","everyday"] },
        { id:"medium", icon:"🌗", title:"A polite nudge", tags:["everyday","starter","lattes"] },
        { id:"low", icon:"😴", title:"Keep it gentle", tags:["evening","cozy"] },
      ]},
    { q: "How new are you to matcha?", three: true,
      options: [
        { id:"new", icon:"🌱", title:"Total beginner", tags:["starter","everyday","cozy"] },
        { id:"some", icon:"🍵", title:"I've had a few", tags:["everyday","lattes"] },
        { id:"deep", icon:"🎎", title:"Deep in the leaves", tags:["umami","ceremonial","sipping"] },
      ]},
  ];

  const mount = document.getElementById('quiz-modal-mount');
  let step = 0, answers = [], done = false, products = [];

  async function loadProducts() {
    if (products.length) return;
    try {
      const res = await fetch('/products.json?limit=50');
      const data = await res.json();
      products = data.products;
    } catch (e) { products = []; }
  }

  function score() {
    const tags = {};
    answers.forEach(a => (a.tags || []).forEach(t => { tags[t] = (tags[t] || 0) + 1; }));
    const scored = products.map(p => {
      const rec = (p.tags || []).filter(t => tags[t]);
      return { p, score: rec.length };
    });
    scored.sort((a, b) => b.score - a.score);
    return scored[0]?.p;
  }

  function render() {
    mount.innerHTML = `
      <div class="overlay-backdrop" data-quiz-close></div>
      <div class="quiz-modal" role="dialog">
        <div class="quiz-prog">
          ${Q.map((_, i) => `<div class="seg ${i <= step ? 'on' : ''}"></div>`).join('')}
        </div>
        <div class="quiz-stage" id="quiz-stage"></div>
        <div class="quiz-foot">
          <button class="btn btn-ghost" data-quiz-back>${step > 0 || done ? '← Back' : '✕ Close'}</button>
          <span class="hand" style="font-size:18px;color:var(--forest);">${done ? 'yay! 🎉' : 'tap an answer'}</span>
        </div>
      </div>`;
    const stage = mount.querySelector('#quiz-stage');
    if (!done) {
      const q = Q[step];
      stage.innerHTML = `
        <div class="eyebrow">Question ${step + 1} of ${Q.length}</div>
        <h2>${q.q}</h2>
        ${q.sub ? `<p class="qsub">${q.sub}</p>` : ''}
        <div class="quiz-options ${q.three ? 'three' : ''}">
          ${q.options.map(o => `<div class="quiz-opt" data-opt='${JSON.stringify(o).replace(/'/g, '&apos;')}'>
            <div class="qicon">${o.icon}</div>
            <h4>${o.title}</h4>
          </div>`).join('')}
        </div>`;
      stage.querySelectorAll('[data-opt]').forEach(el => {
        el.addEventListener('click', () => {
          answers[step] = JSON.parse(el.dataset.opt.replace(/&apos;/g, "'"));
          if (step + 1 < Q.length) step++;
          else done = true;
          render();
        });
      });
    } else {
      const r = score();
      if (!r) {
        stage.innerHTML = `<h2>No matches yet</h2><p>Add products to your store first.</p>`;
        return;
      }
      stage.innerHTML = `
        <div class="quiz-result">
          <div class="eyebrow">Your match</div>
          <h2>You're a <em style="color:var(--vermillion);font-style:italic;">${r.title}</em>.</h2>
          <p class="qsub">${(r.body_html || '').replace(/<[^>]+>/g, '').slice(0, 200)}</p>
          <div class="quiz-match">
            <div class="qm-art" style="background:radial-gradient(circle, var(--accent), var(--primary));">
              ${r.images?.[0] ? `<img src="${r.images[0].src}" style="width:86%;">` : '🍵'}
            </div>
            <div>
              <h3 style="font-family:var(--serif);font-size:26px;margin:4px 0;">${r.title}</h3>
              <a href="${r.handle ? '/products/' + r.handle : '#'}" class="btn">View product →</a>
            </div>
          </div>
          <button class="btn" data-quiz-add data-variant="${r.variants?.[0]?.id || ''}">Add to cart</button>
        </div>`;
      stage.querySelector('[data-quiz-add]')?.addEventListener('click', async (e) => {
        const id = e.currentTarget.dataset.variant;
        if (!id) return;
        await ShopifyCart.add(parseInt(id, 10), 1);
        close();
        Noren.show(() => window.dispatchEvent(new CustomEvent('cart:open')));
      });
    }
    mount.querySelector('[data-quiz-close]').addEventListener('click', close);
    mount.querySelector('[data-quiz-back]').addEventListener('click', () => {
      if (done) { done = false; render(); }
      else if (step > 0) { step--; render(); }
      else close();
    });
  }
  function open() {
    step = 0; answers = []; done = false;
    loadProducts().then(render);
  }
  function close() { mount.innerHTML = ''; }

  window.Quiz = { open, close };
  document.querySelectorAll('[data-open-quiz]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); open(); }));
})();
